<template>
  <div>
    <vx-card class="mb-4">

          <div class="flex flex-col gap-4">
            <div class="flex flex-col gap-2">
              <validation-observer ref="validatorForm">
                <b-form @submit.prevent="createOrUpdate">

                  <validation-provider
                    #default="{ errors }"
                    :name="$t('subgroup_news.name')"
                    rules="required"
                    class="flex-grow"
                    slim>
                    <b-form-group
                      id="input-group-1"
                      :label="$t('subgroup_news.name')"
                      label-for="subgroup_news_name">
                      <b-form-input
                        id="subgroup_news_name"
                        v-model="model.name"
                        :state="errors.length > 0 ? false:null"
                        name="subgroup_news_name"
                        class="required"/>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                  <!-- group_news_id -->
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('group_news.group')"
                    rules="required"
                    class="flex-grow"
                    slim>
                  <select-suggestion
                    column="name"
                    model="GroupNews"
                    v-model="selectedGroupNews"
                    :label="$t('group_news.group')"
                    :appendClearOption="true"
                    placeholderText="Digite o nome do grupo"
                    class="required"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                  <!-- -->
                  <b-form-group
                    class="pt-2"
                    id="input-group-1"
                    :label="$t('subgroup_news.description')"
                    label-for="subgroup_news_description">
                      <b-form-textarea
                        id="subgroup_news_description"
                        v-model="model.description"
                        rows="4"/>
                  </b-form-group>
                </b-form>
              </validation-observer>

            </div>
            <div class="w-full flex gap-2 justify-end">
              <b-button
                v-if="!isEdit()"
                variant="primary"
                :disabled="!validateForm"
                v-permission="'subgroup_news.create'"
                @click="createOrUpdate">
                {{ $t('action.save') }}
              </b-button>
              <b-button
                v-if="isEdit()"
                variant="primary"
                :disabled="!validateForm"
                v-permission="'subgroup_news.edit'"
                @click="createOrUpdate">
                {{ $t('action.save') }}
              </b-button>

              <b-button
                variant="outline-secondary"
                class="float-right"
                @click="goBack">
                <feather-icon
                  icon="CornerUpLeftIcon"
                  class="mr-50"/>
                <span class="align-middle">{{$t('back')}}</span>
              </b-button>
            </div>
          </div>
    </vx-card>
  </div>
</template>

<script>

import standard from '@/services/standard'
import { isAdmin } from '@/util/Util'
import {
  BForm, BButton, BFormGroup, BInputGroup, BFormTextarea, BCardText, BFormInput
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, min, max} from '@validations'
import SelectSuggestion from '@/components/SelectSuggestion.vue'

  import SubgroupNewsService from '@/services/api/SubgroupNewsService'

export default {

  directives: {

  },
  components: {
    BForm,
    BButton,
    BFormGroup,
    BInputGroup,
    BFormTextarea,
    BCardText,
    BFormInput,
    // validations
    ValidationProvider,
    ValidationObserver,
    SelectSuggestion
  },
  props: {
    id: {
      default: null,
      type: Number
    }
  },

  data: () => ({
    service: null,
    model: {
      id: null,
      group_news_id: null,
      name : '',
      description: ''
    },
    selectedGroupNews: null
  }),
  computed: {
    validateForm() {
      return !this.isEmpty(this.model.name)
             && (this.selectedGroupNews !== null && !this.isEmpty(this.selectedGroupNews.id))
    },
  },
  beforeMount() {
    this.service = SubgroupNewsService.build(this.$vs)
  },
  mounted() {
    if (this.id) {
      this.loadData(this.id)
    }
  },

  methods: {
    requiredClass(whichData) {
      return !this.isEmpty(whichData) ? 'w-full' : 'w-full required'
    },
    loadData(id) {
      this.$vs.loading()

      this.service.read(id).then(
        response => {
          this.model = response
          this.selectedGroupNews = response.group
        },
        error => {
          this.$vs.loading.close()
        }
      ).finally(
        () => {
          this.$vs.loading.close()
        }
      )
    },
    createOrUpdate() {
      this.$vs.loading()

      const modelData = {
        id: this.id,
        name: this.model.name,
        group_news_id: this.selectedGroupNews.id,
        description: this.model.description,
      }

      this.service.createOrUpdate(modelData).then(
        data => {
          this.notifySuccess(this.$vs, this.$t('messages.success'))
          this.$router.push(`/subgroup-news/${data.id}/edit`)
        },
        error => {
          //this.showErrors(this.$refs.validatorForm, error)
          //this.notifyError(this.$vs, error);
        }
      ).finally(() => { this.$vs.loading.close() })
    },
    goBack() {
      this.$router.push('/subgroup-news')
    },
    isAdmin() {
      return isAdmin()
    },
    isEdit() {
      return !_.isNil(this.id)
    },
  }
}
</script>

<style>

</style>
